import React, { Component } from 'react';
import { Route, Redirect } from 'react-router'
import { withRouter, Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Register from './Register'
import { Container } from 'semantic-ui-react';
import { Button, Card, CardBody, CardImage, CardTitle, CardText, CardGroup } from 'mdbreact';
import { Auth } from 'aws-amplify';
import FontAwesome from 'react-fontawesome';
import { sample } from 'lodash';


const UserInfo = (props) => {
    return (
        <div>{JSON.stringify(props.user)}</div>
    )
}
const leaderboardSingles = ["acrobat", "africa",  "alaska",  "albino", "album",  "alpha", "amazon", "america",     "analog",          "animal", "antenna", "apollo", "april", "aroma", "artist", "athlete", "atlas", "banana",         "bandit", "banjo", "bingo", "bonus",     "camera", "canada", "carbon", "catalog", "cinema", "citizen", "cobra",     "comet", "compact", "complex", "context", "credit",        "critic", "crystal", "culture", "delta", "dialog",       "diploma", "doctor", "domino", "dragon", "drama", "extra", "fabric", "final",  "focus", "forum", "galaxy",          "gallery", "global", "harmony", "hotel"]

export default class Home extends Component {

    constructor(props) {
        super(props);

        this.state = {
           active_menu: 'home',
           participant_ID: '123xyz',
           leaderboard_Name: 'checkthat',
           leaderBoard_1: sample(leaderboardSingles),
           leaderBoard_2: sample(leaderboardSingles),
           leaderBoard_3: sample(leaderboardSingles),
           leaderBoard_4: sample(leaderboardSingles),
           leaderBoard_5: sample(leaderboardSingles),
           leaderBoard_6: sample(leaderboardSingles),
           leaderBoard_7: sample(leaderboardSingles),
           leaderBoard_8: sample(leaderboardSingles)
        }
        console.log('in Home with state:', this.state);
    }

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    componentDidMount() {
        Auth.currentUserInfo()
            .then(user => this.setState({ user: user }))
            .catch(err => console.log(err));
        console.log('in Home.jsx state values', this.state);
        console.log('in Home.jsx prop values', this.props);
    }


    memberView() {
        const { user } = this.state;
        return (
            <Container>
                Member Home
                <UserInfo user={user} />
            </Container>
        )
    }

    guestView() {
        return (
            <Container>Guest Home</Container>
        )
    }

    userInfo() {
    }

    handleButtonRegisterForm1 = () => {
        this.setState((state, props) => ({
            participant_ID: 'changed1',
            leaderboard_Name: state.leaderBoard_1-state.leaderBoard_2
        }));
        console.log('button pushed');
        <Link to={
            {
                pathname: '/register',
                myCustomProps:{ foo: 'bar'}
            } 
        }/>

        //<Register
        //   leaderboardName = 'check-this-out' 
        //   participant_ID = 'rainy-snow' 
        ///>

        //this.forceUpdate();
        //console.log('before push to register', this.props);
        //this.props.history.push({ pathname:"/register", state: this.props.participant_ID});
        //this.props.history.push({ pathname:"/register"});
        //<Redirect to='/register'/>
    }

    handleButtonNewList = () => {
        this.setState({
            leaderBoard_1: sample(leaderboardSingles),
            leaderBoard_2: sample(leaderboardSingles),
            leaderBoard_3: sample(leaderboardSingles),
            leaderBoard_4: sample(leaderboardSingles),
            leaderBoard_5: sample(leaderboardSingles),
            leaderBoard_6: sample(leaderboardSingles),
            leaderBoard_7: sample(leaderboardSingles),
            leaderBoard_8: sample(leaderboardSingles)
        })
    }

    render() {
        const { authState, authData, participant_ID, match, history, location } = this.props;
        return (
            <CardGroup deck>

<Card>
  <CardImage top src="daily24_logo.jpg" overlay="white-slight" hover waves alt="Card image cap"/>
  <CardBody className="elegant-color white-text rounded-bottom">
    <a className="activator waves-effect waves-light mr-4"></a>
    <CardTitle>{this.state.leaderBoard_1}-{this.state.leaderBoard_2}</CardTitle>
    <hr className="hr-light" />
    <CardText className="white-text"></CardText>
    <Button color="blue-grey" onClick={this.handleButtonRegisterForm1}>Pick this one</Button>
  </CardBody>
</Card>

<Card>
  <CardImage top src="daily24_logo.jpg" overlay="white-slight" hover waves alt="Card image cap"/>
  <CardBody className="elegant-color white-text rounded-bottom">
    <a className="activator waves-effect waves-light mr-4"></a>
    <CardTitle>{this.state.leaderBoard_3}-{this.state.leaderBoard_4}</CardTitle>
    <hr className="hr-light" />
    <CardText className="white-text"></CardText>
    <Button href="#register" color="blue-grey">Pick this one</Button>
  </CardBody>
</Card>

<Card>
  <CardImage top src="daily24_logo.jpg" overlay="white-slight" hover waves alt="Card image cap"/>
  <CardBody className="elegant-color white-text rounded-bottom">
    <a className="activator waves-effect waves-light mr-4"></a>
    <CardTitle>{this.state.leaderBoard_5}-{this.state.leaderBoard_6}</CardTitle>
    <hr className="hr-light" />
    <CardText className="white-text"></CardText>
    <Button href="#register" color="blue-grey">Pick this one</Button>
  </CardBody>
</Card>

<Card>
  <CardImage top src="daily24_logo.jpg" overlay="white-slight" hover waves alt="Card image cap"/>
  <CardBody className="elegant-color white-text rounded-bottom">
    <a className="activator waves-effect waves-light mr-4"></a>
    <CardTitle>{this.state.leaderBoard_7}-{this.state.leaderBoard_8}</CardTitle>
    <hr className="hr-light" />
    <CardText className="white-text"></CardText>
    <Button href="#register" color="blue-grey">Pick this one</Button>
  </CardBody>
</Card>

<Card>
  <CardImage top src="daily24_logo.jpg" overlay="white-slight" hover waves alt="Card image cap"/>
  <CardBody className="elegant-color white-text rounded-bottom">
    <a className="activator waves-effect waves-light mr-4"></a>
    <CardTitle>More Names Please</CardTitle>
    <hr className="hr-light" />
    <CardText className="white-text"></CardText>
    <Button rounded outline onClick={this.handleButtonNewList}> Click for more candidate names </Button>
  </CardBody>
</Card>

</CardGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/Home.jsx